<template>
  <div class="banner" v-lazy-container="{ selector: 'img' }">
    <img :data-src="banner.img" :data-loading="banner.img_loading" class="hidden-xs-only" alt="">
    <img :data-src="banner.smallimg" :data-loading="banner.smallimg_loading" class="hidden-sm-and-up" alt="">
    <div class="content wow fadeInUp" v-if="banner.content">
      <div class="cn" v-text="banner.content.cn"></div>
      <div class="en" v-text="banner.content.en"></div>
    </div>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
import Scrollbar from 'smooth-scrollbar';
export default {
  props: {
    banner: Object
  },
  mounted(){
    let wow=new WOW()
    wow.init()
    this.$nextTick(()=>{
      let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
      scrollbar.addListener((status) => {
        window.pageYOffset=status.offset.y
        wow.scrollHandler()
      });
    })
    
  }
}
</script>

<style scoped>
.banner{
  position: relative;
}
.banner{
  width: 100%;
  display: block;
}
.banner img{
  width: 100%;
}
.banner .content{
  position: absolute;
  top: 60%;
  left: 0;
  width: 100%;
  text-align: center;
  color: #fff;
}
.banner .content .cn{
  font-size: 30px;
}
.banner .content .en{
  font-size: 16px;
  text-transform: uppercase;
}
@media (max-width: 768px){
  .banner .content .cn{
    font-size: 20px;
  }
  .banner .content .en{
    font-size: 12px;
  }
}
</style>
